import React from 'react'
import { Button, Popover, Tooltip } from '@pankod/refine-antd'
import { BgColorsOutlined, BulbFilled, BulbOutlined } from '@ant-design/icons'
import {
  COLOR_THEME_PASTEL,
  COLOR_THEME_VIVID,
  ColorTheme,
  useLayoutContext,
} from 'context/layout'

const renderSwatches = (
  options: typeof COLOR_THEME_VIVID,
  colorTheme: ColorTheme,
  setColorTheme: (theme: ColorTheme) => void,
  pastel = false
) => (
  <div className="ams-color-theme-grid">
    {options.map(option => (
      <Tooltip key={option.id} title={option.label}>
        <button
          type="button"
          className={`ams-color-swatch${pastel ? ' ams-color-swatch--pastel' : ''}${
            colorTheme === option.id ? ' ams-color-swatch--active' : ''
          }`}
          style={{ background: option.swatch }}
          aria-label={`${option.label} theme`}
          onClick={() => setColorTheme(option.id)}
        />
      </Tooltip>
    ))}
  </div>
)

export const ThemeControls: React.FC = () => {
  const { themeMode, colorTheme, toggleThemeMode, setColorTheme } = useLayoutContext()

  const colorPanel = (
    <div className="ams-color-theme-panel">
      <p className="ams-color-theme-title">Vivid</p>
      {renderSwatches(COLOR_THEME_VIVID, colorTheme, setColorTheme)}
      <p className="ams-color-theme-title ams-color-theme-title--spaced">Light pastel</p>
      {renderSwatches(COLOR_THEME_PASTEL, colorTheme, setColorTheme, true)}
    </div>
  )

  return (
    <>
      <Popover
        overlayClassName="ams-color-theme-popover"
        content={colorPanel}
        trigger="click"
        placement="bottomLeft"
      >
        <Button
          type="text"
          className="ams-header-icon-btn"
          aria-label="Choose accent color"
          icon={<BgColorsOutlined />}
        />
      </Popover>
      <Tooltip title={themeMode === 'light' ? 'Switch to dark mode' : 'Switch to light mode'}>
        <Button
          type="text"
          className={`ams-header-icon-btn ams-theme-toggle${themeMode === 'dark' ? ' ams-theme-toggle--dark' : ''}`}
          aria-label={themeMode === 'light' ? 'Switch to dark mode' : 'Switch to light mode'}
          icon={themeMode === 'light' ? <BulbFilled /> : <BulbOutlined />}
          onClick={toggleThemeMode}
        />
      </Tooltip>
    </>
  )
}
